import {InfiniteData, useInfiniteQuery, UseInfiniteQueryResult} from '@tanstack/react-query';
import {conversationApi} from '../api';
import {MessagePage} from '../model';

const PAGE_SIZE = 20;

export type ConversationAudience = 'representative' | 'admin';

export type UseConversationMessagesResult = UseInfiniteQueryResult<InfiniteData<MessagePage>, Error>;

export const useConversationMessages = (
  appealId: string,
  audience: ConversationAudience,
): UseConversationMessagesResult => {
  return useInfiniteQuery<
    MessagePage,
    Error,
    InfiniteData<MessagePage>,
    ['conversation', string, 'messages', ConversationAudience],
    string | undefined
  >({
    queryKey: ['conversation', appealId, 'messages', audience],
    queryFn: ({pageParam}) => {
      const paging = pageParam
        ? {Last: PAGE_SIZE, Before: pageParam}
        : {Last: PAGE_SIZE};

      if (audience === 'admin') {
        return conversationApi.getAdminMessages(appealId, paging);
      }
      return conversationApi.getRepMessages(appealId, paging);
    },
    initialPageParam: undefined,
    getNextPageParam: (firstPage) => {
      return firstPage.pageInfo.hasPreviousPage ? (firstPage.pageInfo.startCursor ?? undefined) : undefined;
    },
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
  });
};
